import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';

import TemplatesListItemCreate from './TemplatesListItemCreate';
import TemplatesListItem from './TemplatesListItem';

const TemplatesList = ({ templates, business, onCreateButtonClick }) => (
  <Grid
    container
    spacing={24}
  >
    <TemplatesListItemCreate
      {...onCreateButtonClick ? { onClick: onCreateButtonClick } : {}}
    />
    {templates.length > 0 &&
      templates.map(item => (
        <TemplatesListItem
          key={item.ID}
          {...item}
          business={business}
        />
      ))
    }
  </Grid>
);

TemplatesList.propTypes = {
  templates: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  onCreateButtonClick: PropTypes.func,
  business: PropTypes.shape({
    ID: PropTypes.number,
    'Time Zone': PropTypes.string,
  }),
};

TemplatesList.defaultProps = {
  onCreateButtonClick: null,
  business: {},
};

export default TemplatesList;



// WEBPACK FOOTER //
// ./src/components/settings/TemplatesList/TemplatesList.js